import { type ICarriersBuyersHourlyData } from './types';

export const TYWallBuyersCarriersHourlyColumns = [
  { name: 'bids', title: 'Bids', compare: 'priority' },
  { name: 'avg_bids', title: 'Bid Avg.', compare: 'priority' },
  { name: 'wins', title: 'Wins', compare: 'priority' },
  { name: 'win_bid', title: 'Winning Bid Avg.', compare: 'priority' },
  { name: 'wins_percent', title: 'Wins %', compare: 'priority' },
  { name: 'clicks', title: 'Clicks', compare: 'priority' },
  { name: 'revenue', title: 'Revenue', compare: 'priority', width: '180' },
  { name: 'epc', title: 'EPC', compare: 'priority' }
];

export const DATE_COLUMN = {
  name: 'date',
  title: 'Date',
  width: 150
};

export const HOUR_COLUMN = {
  name: 'hour',
  title: 'Hour',
  compare: (a: number, b: number) => {
    return a - b;
  },
  width: 150
};

export const TYWallBuyersCarriersTotalMapping = {
  date: { type: 'header' },
  hour: { type: 'header' },
  bids: { type: 'number' },
  bids_count: { type: 'number' },
  avg_bids: {
    type: 'average_currency',
    dividend: (rows: Array<ICarriersBuyersHourlyData>) =>
      rows.reduce((total: number, row: ICarriersBuyersHourlyData) => {
        if (!row) {
          return 0;
        }

        const valueForAverage = row.bids * row.avg_bids;
        return total + parseFloat(`${valueForAverage}`);
      }, 0),
    divisor: (rows: Array<ICarriersBuyersHourlyData>) =>
      rows.reduce((total, row) => {
        if (!row) {
          return 0;
        }
        return total + parseFloat(`${row.bids}`);
      }, 0)
  },
  wins: { type: 'number' },
  wins_percent: { type: 'percent', dividend: 'wins', divisor: 'bids' },
  win_bid: {
    type: 'average_currency',
    dividend: (rows: Array<ICarriersBuyersHourlyData>) =>
      rows.reduce((total, row) => {
        if (!row) {
          return 0;
        }
        const valueForAverage = row.wins * row.win_bid;
        return total + parseFloat(`${valueForAverage}`);
      }, 0),
    divisor: (rows: Array<ICarriersBuyersHourlyData>) =>
      rows.reduce((total, row) => {
        if (!row) {
          return 0;
        }
        return total + parseFloat(`${row.wins}`);
      }, 0)
  },
  clicks: { type: 'number' },
  revenue: { type: 'currency' },
  epc: { type: 'average_currency', dividend: 'revenue', divisor: 'clicks' },
  breakdown: false
};
